import { useState, type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IconArrowDown, IconArrowUp } from '@xing-com/icons';
import { scale060, xdlColorText } from '@xing-com/tokens';

export type AsteriskProps = {
  className?: string;
  legalNotice: ReactNode;
};

export function Asterisk(props: AsteriskProps): JSX.Element {
  const { legalNotice, className = '' } = props;
  const [isExpanded, setIsExpanded] = useState(false);
  const intl = useIntl();
  const AsteriskIcon = isExpanded ? IconArrowUp : IconArrowDown;

  return (
    <AsteriskWrapper className={className}>
      <AsteriskContent data-testid="asterisk-content" isExpanded={isExpanded}>
        {legalNotice}
      </AsteriskContent>
      <AsteriskButton
        data-testid="asterisk-button"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label={intl.formatMessage({
          id: 'UPSELL_PURCHASE_ASTERISK_ARIA_LABEL',
        })}
      >
        <AsteriskIcon data-testid={AsteriskIcon.name} width={24} height={24} />
      </AsteriskButton>
    </AsteriskWrapper>
  );
}

const AsteriskWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const AsteriskContent = styled.p<{ isExpanded: boolean }>`
  flex: 1;
  line-height: 1.25;
  font-size: ${scale060};
  margin: 0;
  display: ${(props) => (props.isExpanded ? 'initial' : '-webkit-box')};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

const AsteriskButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  display: inline-flex;
  padding: 0;
  color: ${xdlColorText};
`;
